import service from '@/services';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { CONTACT_COLUMNS } from '@/types/filterKeyConst';
import { buildObjQuery } from '@/utils/util';

export const useContactFilterMap = () => {
  const workspaceFieldOptions = useWorkspaceStore(
    (state) => state.workspaceFieldOptions,
  );

  const fieldOptions: StructuredFieldOptionMap = {
    [CONTACT_COLUMNS.NAME_SEARCH]: {
      columnKey: CONTACT_COLUMNS.NAME_SEARCH,
      columnName: 'Name',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'pagination',
        filterItemFetcher: async (params) => {
          const cursor = params?.cursor;
          const searchValue = params?.searchValue;
          const queryObj: QueryObj = {
            contact_name: searchValue || null,
            cursor: cursor || null,
            direction: 'next',
            sortby: 'name',
            order: 'asc',
          };
          const queryString = buildObjQuery(queryObj);
          const res = await service.contact.fetchCustomerList(queryString);
          const list: StructuredFilterItem[] = res.map((customer) => ({
            columnKey: CONTACT_COLUMNS.NAME_SEARCH,
            filterKey: customer.name,
            filterName: customer.name,
            filterOptionNode: customer.name,
            searchValue: customer.name,
            cursor: customer.paginate_token,
          }));

          return list;
        },
      },
    },
    [CONTACT_COLUMNS.PLAN]: {
      columnKey: CONTACT_COLUMNS.PLAN,
      columnName: 'Plan',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return workspaceFieldOptions.contact_plan_values
            .map((value) => ({
              columnKey: CONTACT_COLUMNS.PLAN,
              filterKey: value,
              filterName: value,
              filterOptionNode: value,
            }))
            .filter((item) => {
              if (!searchValue) return true;
              return item.filterName.toLocaleLowerCase().includes(searchValue);
            });
        },
      },
    },
    [CONTACT_COLUMNS.STAGE]: {
      columnKey: CONTACT_COLUMNS.STAGE,
      columnName: 'Stage',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return workspaceFieldOptions.contact_stage_values
            .map((value) => ({
              columnKey: CONTACT_COLUMNS.STAGE,
              filterKey: value,
              filterName: value,
              filterOptionNode: value,
            }))
            .filter((item) => {
              if (!searchValue) return true;
              return item.filterName.toLocaleLowerCase().includes(searchValue);
            });
        },
      },
    },
    [CONTACT_COLUMNS.TYPE]: {
      columnKey: CONTACT_COLUMNS.TYPE,
      columnName: 'Type',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return workspaceFieldOptions.contact_type_values
            .map((value) => ({
              columnKey: CONTACT_COLUMNS.TYPE,
              filterKey: value,
              filterName: value,
              filterOptionNode: value,
            }))
            .filter((item) => {
              if (!searchValue) return true;
              return item.filterName.toLocaleLowerCase().includes(searchValue);
            });
        },
      },
    },
    [CONTACT_COLUMNS.JOB_FUNCTION]: {
      columnKey: CONTACT_COLUMNS.JOB_FUNCTION,
      columnName: 'Job function',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return workspaceFieldOptions.job_function_values
            .map((value) => ({
              columnKey: CONTACT_COLUMNS.JOB_FUNCTION,
              filterKey: value,
              filterName: value,
              filterOptionNode: value,
            }))
            .filter((item) => {
              if (!searchValue) return true;
              return item.filterName.toLocaleLowerCase().includes(searchValue);
            });
        },
      },
    },
    [CONTACT_COLUMNS.ALIAS]: {
      columnKey: CONTACT_COLUMNS.ALIAS,
      columnName: 'Alias',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'pagination',
        filterItemFetcher: async (params) => {
          const cursor = params?.cursor;
          const searchValue = params?.searchValue;
          const queryObj: QueryObj = {
            contact_name: searchValue || null,
            cursor: cursor || null,
            direction: 'next',
            sortby: 'name',
            order: 'asc',
          };
          const queryString = buildObjQuery(queryObj);
          const res = await service.contact.fetchCustomerList(queryString);
          const list: StructuredFilterItem[] = res.map((customer) => ({
            columnKey: CONTACT_COLUMNS.ALIAS,
            filterKey: customer.alias,
            filterName: customer.name,
            filterOptionNode: `${customer.name} (${customer.alias})`,
            searchValue: customer.name,
            cursor: customer.paginate_token,
          }));
          return list;
        },
      },
    },
  };

  return fieldOptions;
};
